import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import Flex from '../Flex'
import { borderRadius } from 'styled-system'
import Box from '../Box'
import Copy from '../Copy'
import Icon from '../Icon'

const IconContainer = styled(Flex)`
    ${borderRadius}
    line-height: 30px;
    color: rgba(0,0,0,.6);
`

const BoxContainer = styled(Box)`
    @keyframes fade-in {
        0% { opacity: 0% }
        100% { opacity: 100%; }
    }
    @keyframes fade-out {
        0% { opacity: 100%; height: auto; }
        99% { opacity: 0%; height: auto; }
        100% { opacity: 0%; height: 0; }
    }
    height: auto;
    overflow-x: hidden;
    opacity: 100%;
    animation: fade-in ${({ timeIn }) => timeIn} ease-in forwards, fade-out ${({ timeOut }) => timeOut} ${({ duration }) => duration} ease-out forwards;
`
const Container = styled(Box)`
    @keyframes fade-in-content {}
    @keyframes fade-out-content {
        0% { margin-left: 0px; }
        100% { margin-left: 200px; }
    }
    animation: fade-in-content ${({ timeIn }) => timeIn} ease-in forwards, fade-out-content ${({ timeOut }) => timeOut} ${({ duration }) => duration} ease-out forwards;
`
const RoundedBlock = styled(Box)`
    border-radius: 4px;
`

const FlipBox = ({ timeIn, timeOut, duration, children, ...restProps }) =>
    <BoxContainer textAlign='right' width='100%' timeIn={timeIn} timeOut={timeOut} duration={duration} {...restProps}>
        <Container width='100%' timeIn={timeIn} timeOut={timeOut} duration={duration}>
            {children}
        </Container>
    </BoxContainer>

FlipBox.propTypes = {
    timeIn: PropTypes.string,
    timeOut: PropTypes.string,
    duration: PropTypes.node,
    children: PropTypes.node,
}

const Message = ({ message, title, background, iconBackground, iconColor, iconSize, icon, fontSize, fontColor, actionButton, image, animated, fontWeightMessage, fontWeightTitle }) => {
    const Container = animated ? FlipBox : Box
    return <Container timeIn='0.5s' timeOut='0.3s' duration='8s' mb='8px'>
        <RoundedBlock background={background} width='100%' textAlign='left'>
            <Flex padding='0.5em' width='100%'>
                {(icon || image) && <IconContainer justifyContent='center' w='30px' h='30px' marginRight='0.5em' background={iconBackground} borderRadius='50%' textAlign='center'>
                    {icon && <Box width='40px'>
                        <Icon type={icon} fontSize={iconSize} fontColor={iconColor} />
                    </Box>}
                    {image && <Flex justifyContent='center'>
                        {image}
                    </Flex>}
                </IconContainer>}
                <Box alignSelf='center' width={(icon || image) ? 'calc(100% - 40px)' : '100%'}>
                    {title && <Copy padding='0.3em 0 0.3em 0' fontColor={fontColor} fontSize={fontSize} fontWeight={fontWeightTitle}>
                        {title}
                    </Copy>}
                    <Copy padding='0.3em 0 0 0' fontColor={fontColor} fontSize={fontSize} fontWeight={fontWeightMessage}>
                        {message}
                    </Copy>
                    {actionButton}
                </Box>
            </Flex>
        </RoundedBlock>
    </Container>
}

Message.propTypes = {
    title: PropTypes.node,
    message: PropTypes.node,
    background: PropTypes.string,
    iconBackground: PropTypes.string,
    fontColor: PropTypes.string,
    fontSize: PropTypes.string,
    iconColor: PropTypes.string,
    iconSize: PropTypes.string,
    icon: PropTypes.string,
    image: PropTypes.node,
    animated: PropTypes.bool,
    actionButton: PropTypes.node,
    fontWeightTitle: PropTypes.any,
    fontWeightMessage: PropTypes.any,
}

Message.defaultProps = {
    fontColor: 'black',
    fontSize: 'small',
    fontWeightTitle: 'medium',
    fontWeightMessage: 'light',
    iconColor: 'black',
    iconBackground: 'accent20',
    background: 'accent20',
    iconSize: 'medium',
    animated: true,
}

Message.success = styled(Message)``

Message.success.defaultProps = {
    fontSize: 'xSmall',
    fontWeightTitle: 'book',
    iconColor: 'accent_dark',
    iconBackground: 'transparent',
    background: 'accent40',
    fontColor: 'darkGray',
    icon: 'ok'
}

Message.error = styled(Message)``

Message.error.defaultProps = {
    fontSize: 'xSmall',
    fontWeightTitle: 'book',
    iconColor: 'error_dark',
    iconBackground: 'transparent',
    background: 'error40',
    fontColor: 'darkGray',
    icon: 'x'
}

export default Message
